<template>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <slot name="header">
                Privacy policy
              </slot>
            </div>
  
            <div class="modal-body">
              <slot name="body">
                Pursuant to California’s privacy law, namely California Consumer Privacy Act, 2018, into effect on 1st January 2020, we have revised our privacy policy to include the following California-resident specific consumer rights.<br/>
                <br/>
                To the extent that the personal data applies to a 'consumer', as defined under the California Consumer Privacy Act of 2018 ("CCPA") and Media Pay Plus Ltd is a 'business' as defined under CCPA, the following applies to the data protection changes we adhere to in response to a verifiable consumer request of Californians.<br/>
                <br/>
                These consumer requests are embedded into:<br/>
                <ul>
                  <li>The right of Californians to know what personal information is being collected about them.</li>
                  <li>The right of Californians to know whether their personal information is sold or disclosed and to whom.</li>
                  <li>The right of Californians to say no to the sale of personal information and opt-out of data sale.</li>
                  <li>The right of Californians to access their personal information.</li>
                  <li>The right of Californians to exercise their privacy rights to delete personal information.</li>
                </ul>
                <br/>
                ‘Right to be left alone’<br/>
                If a consumer seeks to exercise the foregoing rights to access or delete personal data which constitutes 'personal information' as defined in CCPA, consumers may contact and write to us in order to perform their ‘right to be left alone’. We respond to all requests we receive to service the data protection rights within a reasonable timeframe in accordance with applicable data protection laws.<br/>
                <br/>
                Disclosure and delivery of the required information to a consumer is free of charge and performed within ultimately 45 days of receiving a verifiable request from the consumer. Opt-outs of data sales are handled and made effective within ten (10) days of receipt of an opt-out of data sale verification.<br/>
                <br/>
                ‘Do not sell my personal information’<br/>
                We have included two steps for a do-not sell request of personal data, whereby the consumer can submit the request to opt out of the sale of his/her personal information. This California-specific opt-out mechanism can be done on the website under the title ‘Do Not Sell My Personal Information’: https://customercare.today/us/.<br/>
                <br/>
                Further<br/>
                Media Pay Plus Ltd does not sell and share the personal data if it has not received the prior informed opt-in consent from the consumer and is provided an opportunity to exercise the right to opt out.<br/>
                The categories of personal data collected and disclosed about consumers and the categories/sectors of third parties are described under the heads ‘Sharing of personal data’ and 'Why does  Media Pay Plus Ltd  collect personal data'. In order to opt-out of data processing in advance, prior to any entry, consumers have the option to choose to participate to the promotion without sharing personal data to the business partners. After participation the consumer’s decision to opt out will endure for at least 12 months.<br/>
                <br/>                
                Any feedback or request, please go to next page.<br/>
              </slot>
            </div>
  
            <div class="modal-footer">
              <slot name="footer">
                <button @click.prevent="$emit('close')">close</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
</template>
<script>
// register modal component
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

library.add(faUserSecret);

export default {
    name: 'Modal'
}
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-width: 600px;
  width: 90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  border-radius: 30px;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  font-size: 0.5em;
  text-align: left;
  height: 50vh;
  overflow: scroll;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

button {
  padding: 10px 50px;
  font-size: 1.0em;
  text-transform: capitalize;
}

@media only screen and (max-width : 640px) {
  .modal-container {
    border-radius: 0px;
  }
}
</style>